import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
// import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from '@npkg/vue-router'
import HomeView from '../views/home/HomeView.vue'
import i18n from '@/locale'
// console.log(i18n);
let t = i18n.global;



const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/home',
    meta: {
      title: t.t('navMenu.home')
    },
    children: [
      {
        path: '/home',
        name: 'home',
        component: HomeView,
        meta: {
          title: t.t('navMenu.home')
        },
      },
      {
        path: '/about',
        name: 'companyInfor',
        component: () => import('@/views/companyInfor/index.vue'),
        meta: {
          title: t.t('navMenu.aboutUs')
        },
      },
      {
        path: '/serve',
        name: 'riskCompliance',
        component: () => import('@/views/riskCompliance/index.vue'),
        meta: {
          title: t.t('navMenu.assessServe')
        }
      },
      {
        path: '/product',
        name: 'regulatoryTechProduct',
        component: () => import('@/views/regulatoryTechProduct/index.vue'),
        meta: {
          title: t.t('navMenu.teleProduct')
        }
      },
      {
        path: '/recruit',
        name: 'talentRecruitment',
        component: () => import('@/views/talentRecruitment/index.vue'),
        redirect: '/recruit/index',
        children: [
          { 
            path: 'index',
            name: 'recruit',
            component: () => import('@/views/talentRecruitment/recruit.vue'),
          },
          { 
            path: 'filling',
            name: 'filling',
            component: () => import('@/views/talentRecruitment/filling.vue'),
          },
        ],
      },
      {
        path: '/news',
        name: 'newsList',
        component: () => import('@/views/news/index.vue'),
        redirect: '/news/index',
        meta: {
          title: t.t('page.news'),
        },
        children: [
          { 
            path: 'index',
            name: 'newList',
            component: () => import('@/views/news/list.vue'),
            meta: {
              title: t.t('page.newsList'),
            },
          },
          { 
            path: 'detail',
            name: 'listDetail',
            component: () => import('@/views/news/news-detail.vue'),
            meta: {
              title: t.t('page.newsDetail'),
            },
          }
        ]
      }
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  // history: createWebHistory(),
  routes
})

export default router
